<div class="survey-container rounded bg-poll">
  <div class="survey-header text-center">
    <div class="image-container-polls w-100 overflow-hidden position-relative bg-white rounded-top">
      <img class="h-100 w-100" src="{{ survey.ImageURL | contentImage: '1' }}" alt="{{ survey.ImageURL }}" />
    </div>
    <div class="survey-info">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <span class="svg svg-white poll d-inline-block my-0" [inlineSVG]="'assets/images/icons/nav-polls.svg'"> </span>
        </div>
        <div class="px-3 d-none d-lg-block text-white">{{ survey.SurveyQuestion }}</div>

        <div
          class="text-center fw-bold text-tertiary font-size-16"
          [ngClass]="pointsWon > 0 ? 'd-block d-lg-none' : 'd-none'"
        >
          +{{ pointsWon }} Pts
        </div>
        <div class="text-end text-white" [ngClass]="{ countdown: survey.HasBeenAnsweredByUser }">
          <span class="icon icon-clock pe-1"></span>
          <fgb-countdown
            [endDateTime]="survey.EndDate"
            [requestDateTime]="survey.RequestTime"
            [isUTC]="false"
            class="font-size-16 fw-bold"
          ></fgb-countdown>
        </div>
      </div>
      <div class="px-3 d-block d-lg-none mt-3 text-white font-size-14">{{ survey.SurveyQuestion }}</div>
    </div>
  </div>
  <ng-container *ngIf="survey.HasBeenAnsweredByUser; else answer">
    <fgb-survey-item-answer-completed-poll [survey]="survey" [pointsWon]="pointsWon"></fgb-survey-item-answer-completed-poll>
  </ng-container>
  <ng-template #answer>
    <fgb-survey-item-answer [survey]="survey"></fgb-survey-item-answer>
  </ng-template>
</div>
